module.exports = __webpack_public_path__ + "img/pay.711677f1.png";